import {Navigate, Outlet, useLocation} from "react-router-dom";
import ActivityFooter from "../services/ActivityFooter";
import CommandPalette from "../components/CommandPalette";
import BulkActionsBar from "../components/BulkActionsBar";
import TaskTemplatesDialog from "../components/TaskTemplatesDialog";
import KeyboardShortcutsHelp from "../components/KeyboardShortcutsHelp";
import MeetingNotesDialog from "../components/MeetingNotesDialog";
import DailyPlannerDialog from "../components/DailyPlannerDialog";
import useKeyboardShortcuts from "../hooks/useKeyboardShortcuts";

export default function AppLayout() {
    useKeyboardShortcuts(true);
    return <main className="App">
        <Outlet/>
        <ActivityFooter />
        <CommandPalette />
        <BulkActionsBar />
        <TaskTemplatesDialog />
        <KeyboardShortcutsHelp />
        <MeetingNotesDialog />
        <DailyPlannerDialog />
    </main>;
}
